import { render, staticRenderFns } from "./LastPositions.vue?vue&type=template&id=41ed1653"
import script from "./LastPositions.vue?vue&type=script&lang=js"
export * from "./LastPositions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports